import { CheckoutFormSection } from './checkoutForm';

enum CheckoutFormSectionLabel {
    contactInfo = 'ContactInformation',
    attendees = 'AttendeesInformation',
    tosCheckbox = 'ToSCheckbox',
    payment = 'Payment',
}

export const CHECKOUT_FORM_SECTION_LABEL: Record<
    CheckoutFormSection,
    CheckoutFormSectionLabel
> = {
    [CheckoutFormSection.attendees]: CheckoutFormSectionLabel.attendees,
    [CheckoutFormSection.contactInfo]: CheckoutFormSectionLabel.contactInfo,
    [CheckoutFormSection.payment]: CheckoutFormSectionLabel.payment,
    [CheckoutFormSection.tosCheckbox]: CheckoutFormSectionLabel.tosCheckbox,
};
